import { inputClass, labelClass } from "./styles";

const HEX_RE = /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/;

/** A color swatch (native picker) paired with a free-text hex input. */
export function ColorField({
  id,
  label,
  value,
  onChange,
}: Readonly<{
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
}>) {
  const isValidHex = value === "" || HEX_RE.test(value);
  const swatchValue = HEX_RE.test(value) ? value : "#000000";
  return (
    <div>
      <label htmlFor={id} className={labelClass}>
        {label}
      </label>
      <div className="flex items-center gap-2">
        <input
          type="color"
          aria-label={`${label} color picker`}
          value={swatchValue}
          onChange={(e) => onChange(e.target.value)}
          className="h-9 w-10 shrink-0 cursor-pointer rounded border border-border-secondary bg-surface-secondary p-0.5"
        />
        <input
          id={id}
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder="#003366"
          className={inputClass}
        />
      </div>
      {!isValidHex && <p className="mt-1 text-xs text-red-400">Enter a valid hex color (e.g. #003366).</p>}
    </div>
  );
}
